import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface Animal {
  _id: string | null;
  gn: string | null;
  farmer: string | null;
  birthDate: string | null;
  sex: string | null;
  breedingType: string | null;
  name: string | null;
  farm: string | null;
  age: string | null;
  motherDGR: string | null;
  motherName: string | null;
  fatherDGR: string | null;
  fatherName: string | null;
  motherBreed: string | null;
  fatherBreed: string | null;
  grandMotherName: string | null;
  grandMotherBreed: string | null;
  grandMotherDGR: string | null;
  grandFatherName: string | null;
  grandFatherBreed: string | null;
  grandFatherDGR: string | null;
  vaccination: string | null;
  coatColor: string | null;
  size: string | null;
  paternalNucleus: string | null;
  paternalType: string | null;
  racialComposition: string | null;
  weight: string | null;
  phases: [];
  createdAt: string | null;
  updatedAt: string | null;
  __v: number;
}

interface AnimalStore {
  animalInfo: Animal;
  updateAnimalInfo: (partialData: Partial<Animal>) => void;
  setAnimalInfo: (data: Animal) => void;
  clearAnimalInfo: () => void;
}

const animalInitialState: Animal = {
  _id: null,
  gn: null,
  farmer: null,
  birthDate: null,
  sex: null,
  breedingType: null,
  name: null,
  age: null,
  farm: null,
  motherDGR: null,
  motherName: null,
  fatherDGR: null,
  fatherName: null,
  motherBreed: null,
  fatherBreed: null,
  grandMotherName: null,
  grandMotherBreed: null,
  grandMotherDGR: null,
  grandFatherName: null,
  grandFatherBreed: null,
  grandFatherDGR: null,
  vaccination: null,
  coatColor: null,
  size: null,
  paternalNucleus: null,
  paternalType: null,
  racialComposition: null,
  weight: null,
  phases: [],
  createdAt: null,
  updatedAt: null,
  __v: 0,
};

export const AnimalStore = create<AnimalStore>()(
  persist(
    (set) => ({
      animalInfo: animalInitialState,

      setAnimalInfo: (data: Animal) => {
        set({ animalInfo: data });
      },

      updateAnimalInfo: (partialData: Partial<Animal>) => {
        set((state) => ({
          animalInfo: { ...state.animalInfo, ...partialData },
        }));
      },

      clearAnimalInfo: () => {
        set({ animalInfo: animalInitialState });
      },
    }),
    {
      name: "animal",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
